const apiResponseStub = {
    products: [
        {
            title: 'Flexi-Seal <sup>3</sup> PROTEXT FMS',
            description: 'Some <sub>3</sub> description <sup>TM</sup> jashdf lkasj dhfl aksjdhfklasj dhflkasj dfklasjd hflaksjdh faklsjdh falksdjh flaksdjh flaksdjhf laksdjhf laksjdhf aklsjdh falksjdfh akjs',
            url: '/ostomy/new-page23/',
            image: 'https://dotcom-dev.dxp.convatec.com/siteassets/test/8725e33333932fc56e7b028e6c301bd1.jpg?width=875',
            linkText: 'Read more',
        },
        {
            title: 'level-three',
            description: 'Some description kajshd fkasjh dfkajsh dfkajsh dfkasjd hfkjasd hfk asj dhfkajs dhfkasjdhfkasjhd fkasj dhfkasj dhfkasjd hfkas dhfkasjdh fkasjdh fkasjdhfkasjdhfkasjdhfaksjdhfaksjdhf askd fhaskd faksjdh faksjdhf aksjdhf kasjdhf kasjdhf kasjdhf aksjdfh akjs',
            url: '/testpage-pk/level-two/level-three/',
            image: 'https://dotcom-dev.dxp.convatec.com/siteassets/test/8725e33333932fc56e7b028e6c301bd1.jpg?width=876',
            linkText: 'Read more',
        },
        {
            title: 'Level 3',
            description: 'Some description',
            url: '/ostomy/new-page2/new-page23/',
            image: 'https://dotcom-dev.dxp.convatec.com/siteassets/test/8725e33333932fc56e7b028e6c301bd1.jpg?width=876',
            linkText: 'Read more',
        },
    ],
};

export { apiResponseStub };
